<template>
    <div class="c-form-item" :class="[{'c-form-item--horizontal': horizontal}, customClass ? customClass : '', fluid ? 'c-form-item--fluid':'']">
        <v-label :custom-class="[customLabelClass, !horizontal ? 'c-block' : '']" :id="name">
            <slot name="label"></slot>
        </v-label>
        <vue-editor v-if="autofocus"
                :id="name" 
                :name="name" 
                :class="`c-form-element c-textarea`"
                v-model="rteValue" 
                :editorToolbar="toolbar"
                :disabled="readOnly"
                @blur="change">
        </vue-editor>
        <vue-editor v-else
                :id="name" 
                :name="name" 
                :class="`c-form-element c-textarea`"
                v-model="rteValue" 
                :editorToolbar="toolbar"
                :disabled="readOnly"
                @blur="change">
        </vue-editor>
    </div>
</template>

<script>
    import VLabel from './Label.vue'
    import { VueEditor } from "vue2-editor";

    export default {
        components: {
            VLabel,
            VueEditor
        },
        directives: {
            focus: {
                inserted(el) {
                    el.focus()
                }
            }
        },
        props: {
            'name': String,
            'toolbar': {type: Array, default: [
                [{ 'font': [] }],
                [{ 'header': [false, 1, 2, 3, 4, 5, 6, ] }],
                [{ 'size': ['small', false, 'large', 'huge'] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
                [{ 'header': 1 }, { 'header': 2 }],
                ['blockquote', 'code-block'],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
                [{ 'script': 'sub'}, { 'script': 'super' }],
                [{ 'indent': '-1'}, { 'indent': '+1' }],
                [{ 'color': [] }, { 'background': [] }],
                ['link', 'image', 'video', 'formula'],
                [{ 'direction': 'rtl' }],
                ['clean'],
            ]},
            'custom-class': String,
            'custom-label-class': String,
            'value': String,
            fluid: {type: Boolean, default: true},
            'autofocus': {type: Boolean, default: false},
            horizontal: {type: Boolean, default: true},
            readOnly: {type: Boolean, default: false}
        },
        computed: {
            rteValue: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            }
        },
        methods: {
            change(value) {
                this.$emit('blur', this.value);
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/form/RichTextEditor.vue